"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("show-test-question", require("./Question.vue").default);

exports.default = {
  props: ["heading", "unique", "test", "old"],

  data: function data() {
    return {
      values: this.setValues()
    };
  },


  /**
   * Computed
   */
  computed: {
    /**
     * Show reference value
     * @returns {boolean}
     */
    showReferenceValue: function showReferenceValue() {
      return this.test.type.template_type !== "questionnaire";
    }
  },

  methods: {
    getQuestionValue: function getQuestionValue(question) {
      return _(this.values).filter(function (q) {
        return q.id == question.unique;
      }).first().value;
    },
    setValues: function setValues() {
      var _this = this;

      return _(this.heading.questions).map(function (question) {
        return {
          id: question.unique,
          value: _this.getOldOrTestValue(question)
        };
      }).value();
    },
    getOldOrTestValue: function getOldOrTestValue(question) {
      try {
        return eval("this.old." + this.unique.join(".") + ".questions." + question.unique);
      } catch (error) {}

      var test = this.test;

      if (test) {
        var answer = void 0;

        try {
          answer = eval("this.test." + this.unique.join(".") + ".questions." + question.unique);
        } catch (err) {
          answer = "";
        }

        return answer;
      }

      return null;
    },
    generateUnique: function generateUnique(unique, type) {
      return _.concat(this.unique, [type, unique]);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/Heading.vue
// module id = ifbv
// module chunks = 0 1